import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageSheet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="data-catalog-lineage-sheet_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".data-catalog-lineage-sheet_svg__st0{fill:#666}"}</style>
    <path
      id="data-catalog-lineage-sheet_svg__Bar3_7_"
      className="data-catalog-lineage-sheet_svg__st0"
      d="M14 9h1v8h-1z"
    />
    <path
      id="data-catalog-lineage-sheet_svg__Bar2_7_"
      className="data-catalog-lineage-sheet_svg__st0"
      d="M11 8h1v9h-1z"
    />
    <path
      id="data-catalog-lineage-sheet_svg__Bar1_7_"
      className="data-catalog-lineage-sheet_svg__st0"
      d="M8 11h1v6H8z"
    />
    <path
      id="data-catalog-lineage-sheet_svg__SquareOutline_3_"
      className="data-catalog-lineage-sheet_svg__st0"
      d="M18 5H5c-.5 0-1 .4-1 1v13c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V6c0-.6-.5-1-1-1zm0 14H5V6h13v13z"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageSheet);
export default Memo;
